import { ContextProp } from '../types/ViewModel/ContextProp';

export const GetProp = (value: boolean, isDirty: boolean): ContextProp => {
    return new ContextProp(value, isDirty);
};

export const numberExists = (value: number | null | undefined) => {
    return value !== null && value !== undefined;
};
